<template>
    <div class="kleptos-desktop">

        <!-- WALLPAPER -->
        <div class="kleptos-desktop-wallpaper"></div>

        <!-- LOGO -->
        <!-- <DesktopLogo/> -->

        <!-- FILE SYSTEM ICON VIEW -->
        <FileSystemIconView
            :directory="desktop"
            :constrain="false"
        />

    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import DesktopLogo from './DesktopLogo';
    import FileSystemIconView from '../Programs/FileSystem/FileSystemIconView/FileSystemIconView.vue';

    export default {
        components: {
            DesktopLogo,
            FileSystemIconView
        },
        props: {
            theme: {
                type: String,
                required: true
            }
        },
        computed: {
            ...mapGetters('gameOS', {
                localFileSystem: 'getLocalFileSystem',
                windows: 'getWindows'
            }),
            desktop() {
                return this.localFileSystem.children[0].children; // need getNode('/Desktop');
            }
        }
    }
</script>

<style lang="scss" scoped>

    //-----------------------------------------------------------------
    // DESKTOP
    //-----------------------------------------------------------------

    .kleptos-desktop {
        display: flex; // [LOCKED] - logo
        position: absolute; // [LOCKED]
        top: rem-calc(40); // [LOCKED] - topbar - todo: make var
        bottom: rem-calc(40); // [LOCKED] - taskbar - todo: make var
        width: 100%; // [LOCKED]
    }

    //-----------------------------------------------------------------
    // WALLPAPER
    //-----------------------------------------------------------------

    .kleptos-desktop-wallpaper {
        position: absolute;
        top: rem-calc(-40); // topbar - todo: make var
        left: 0;
        width: 100%;
        height: calc(100% + #{rem-calc(80)}); // taskbar - todo: make var
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
        background-color: #1c1c21; // [LOCKED] - nearblack fallback
        // -webkit-filter: grayscale(1);
        // filter: grayscale(1);
    }

    .theme-95 .kleptos-desktop-wallpaper {
        background: #54aaaa;
        // background: #667e80;
        // background-image: url('~@/assets/img/wallpaper-95.jpg'); //#1c1c21
    }

    .theme-os .kleptos-desktop-wallpaper {
        background-image: url('./assets/img/wallpaper-os.jpg'); //#1c1c21
    }
</style>